import { getWindow, isSsr } from './general';

export const getAuthorizationToken = (): string =>
  getWindow()?.THDCustomer?.default?.token ?? '';

export const getSvocId = (): string | null | undefined =>
  getWindow()?.THDCustomer?.default?.svocID;

export const getUserId = (): string | null | undefined =>
  getWindow()?.THDCustomer?.default?.userID;

export const getCustomerType = (): string | null | undefined =>
  getWindow()?.THDCustomer?.default?.customerType;

export const isB2BUser = (): boolean | null | undefined =>
  getWindow()?.THDCustomer?.default?.isB2BCustomer;

export const isB2CUser = (): boolean | null | undefined =>
  getWindow()?.THDCustomer?.default?.isB2CCustomer;

export const getMemberId = (): string | null | undefined => {
  if (isSsr) return null;

  const token = getAuthorizationToken();
  const svocId = getSvocId();

  if (token && svocId) return svocId;

  return getWindow()?.THDCustomer?.default?.userID;
};

// Namespaces a client-storage key by the current account so a value saved by
// one logged-in user/business account never bleeds into another's session on
// a shared machine. Returns null when no member id is resolvable yet (e.g.
// before THDCustomer has loaded) rather than falling back to a shared bucket,
// since a shared bucket would reintroduce the same cross-account bleed this
// exists to prevent; callers should skip the read/write in that case.
export const getAccountScopedStorageKey = (baseKey: string): string | null => {
  const memberId = getMemberId();
  return memberId ? `${baseKey}:${memberId}` : null;
};

export const VIEW_TYPE_STORAGE_KEY = 'viewType';
